import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [
  {
    path: "",
    title: "MENUITEMS.MAIN.TEXT",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    submenu: [],
  },
  
 {
    path: "dashboard/",
    title: "MENUITEMS.DASHBOARD.TEXT",
    iconType: "feather",
    icon: "home",
    class: "",
    groupTitle: false,

    submenu: [
    ],
  },

  {
    path: "",
    title:"MENUITEMS.USERS.TEXT",
    iconType: "feather",
    icon: "feather",
    class: "menu-toggle",
    groupTitle: false,
    submenu: [
  
      {
        path: "/users",
        title: "MENUITEMS.USER_LIST.TEXT",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        submenu: [],
      },
   /*   {
        path: "/settings",
        title: "MENUITEMS.SETTINGS.TEXT",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        submenu: [],
      },
      {
        path: "/databases",
        title: "MENUITEMS.DATABASES.TEXT",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        submenu: [],
      },
      {
        path: "#",
        title: "MENUITEMS.ROLES_RIGHTS.TEXT",
        iconType: "",
        icon: "",
        class: "menu-toggle ml-menu",
        groupTitle: false,
        submenu: [
          {
            path: "/modules",
            title: "MENUITEMS.MODULES.TEXT",
            iconType: "",
            icon: "",
            class: "ml-menu-2",
            groupTitle: false,
            submenu: [],
          },
    
         {
            path: "/screens",
            title: "MENUITEMS.SCREENS.TEXT",
            iconType: "",
            icon: "",
            class: "ml-menu-2",
            groupTitle: false,
            submenu: [],
          },
          {
            path: "/actions",
            title: "MENUITEMS.ACTIONS.TEXT",
            iconType: "",
            icon: "",
            class: "ml-menu-2",
            groupTitle: false,
            submenu: [],
          },
      

        ],
      },*/
    ],
  },

];